import React, { useState, useEffect } from "react";
import slugify from "slugify";
import { If } from "react-condition";
import { useParams } from "react-router-dom";
import axios from "../../../services/axios";

function Checkbox({
  onBlurHandler,
  isInputFieldTouched,
  data,
  defaultValue,
  isChild,
  approve,
  hasChiledReadOnly,
  ocrDisabled,
  errorInputs,
}) {
  const { id, ids } = useParams();
  const formId = id;
  const candidateId = ids;
  const [defValue, setDefValue] = useState("");

  const [element, setElement] = useState({
    type: "checkbox",
    properties: {
      label: "Checkbox question field.",
      options: [],
      columns: 1,
      value: [],
    },
    required: false,
  });

  const [readOnly, setReadOnly] = useState(false);

  //set child to required by default -Lovejot(08-DEC-2022)
  useEffect(() => {
    let objProperties = { ...data?.properties };
    let val = objProperties.value;
    let safeArr = Array.isArray(val)
      ? [...val]
      : typeof val === "string" && val.trim()
      ? val.split(",").map((s) => s.trim())
      : [];
    setElement({
      ...data,
      properties: {
        ...objProperties,
        value: safeArr,
      },
    });

    // if (isChild) {
    //   let obj = { ...data };
    //   obj.properties.required = true;
    //   setElement((prev) => ({ ...prev, ...obj }));
    // }

    //check prefilled field -Lovejot(07-DEC-2022)
  }, [data, isChild]);

  const handleChange = (e, index) => {
    const { checked } = e.target;
    let currentVal = Array.isArray(element?.properties?.value) ? element.properties.value : [];
    if (checked) {
      currentVal.push(e.target.value);
      setElement({
        ...element,
        properties: { ...element.properties, value: currentVal },
      });
    } else {
      const removedIndex = currentVal.indexOf(e.target.value);
      if (removedIndex > -1) {
        currentVal.splice(removedIndex, 1);
      }
      setElement({
        ...element,
        properties: { ...element.properties, value: currentVal },
      });
    }
  };

  const isChecked = (val, compareValue) => {
    if (compareValue && Array.isArray(compareValue)) {
      const index = compareValue?.findIndex((a) => a === val);
      if (index !== -1) return true;
    }

    // console.log( "checkbox value", compareValue);
    switch (val) {
      case "FRI":
        return true;
      case "SUN":
        return true;
      case "SAT":
        return true;
      default:
        return null;
    }
  };

  const foundError = errorInputs?.find(
    (ele) => ele?.label === element?.properties?.label
  );

  return (
    <div
      className="form-group mb-3 col-md-12 form-builder-element"
      data={JSON.stringify(element)}
    >
      <label htmlFor="">
        {element.properties.label}
        <If test={element?.properties?.required === true}>
          <span style={{ color: "red" }}>*</span>
        </If>
      </label>
      <div className="row">
        {element?.properties?.options?.map((v, k) => (
          <div key={k} className={"col-md-" + 12 / element.properties.columns}>
            <div className="custom-control custom-checkbox mb-3">
              <input
                onBlur={onBlurHandler}
                disabled={
                  approve ||
                  !element.editable ||
                  (defValue && hasChiledReadOnly) ||
                  ocrDisabled
                }
                type="checkbox"
                className="custom-control-input form-view"
                id={slugify(element.properties.label) + k}
                label={element.properties.label}
                data={JSON.stringify(element)}
                name={slugify(element.properties.label)}
                //name={v}
                onChange={(e) => {
                  handleChange(e, k);
                  if (isInputFieldTouched) {
                    isInputFieldTouched();
                  }
                }}
                checked={isChecked(v, element?.properties?.value)}
                value={v}
              />
              <label
                className={
                  "custom-control-label" + (foundError ? " error_checkbox" : "")
                }
                htmlFor={slugify(element.properties.label) + k}
              >
                {/* {k + 1}. {v} */}
                {v}
              </label>
            </div>
          </div>
        ))}
        {foundError && (
          <span className="text-danger pl-3">{foundError?.value}</span>
        )}
      </div>
    </div>
  );
}

export default Checkbox;
